module.exports = __webpack_public_path__ + "img/5f_r_twodays.fcd4b1b9.png";